import { type VehicleDetailsQueryResult } from '../types/vehicle-details-query.types.ts'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { fetchVehicleDetails } from '../api/vehicle.service'
import { useMemo } from 'react'

export const vehicleDetailsDataQueryOptions = (vin: string) =>
  queryOptions({
    queryKey: ['vehicles', vin],
    queryFn: ({ signal }) => fetchVehicleDetails(vin, signal)
  })

export const useVehicle = (vin: string): VehicleDetailsQueryResult => {
  const query = useSuspenseQuery(vehicleDetailsDataQueryOptions(vin))

  return useMemo(
    () => ({
      vin,
      data: query.data,
      error: query.error
    }),
    [vin, query.data, query.error]
  )
}
